/* eslint-disable */
import React, {useState} from 'react'
import Carousel from 'nuka-carousel'
import UiFx from 'uifx'
import Slider from 'react-slick'

// Styles
import './PlayerInventoryModule.scss'
import Button from 'react-bootstrap/Button'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

// Component
import PlayerInventoryModal from './PlayerInventoryModal/PlayerInventoryModal'
// import InventoryNextButton from './InventoryNextButton/InventoryNextButton';
// import InventoryPrevButton from './InventoryPrevButton/InventoryPrevButton';

// Image Imports
import RuinsPrev from '../../../images/ruins_prev.png'
import RuinsNext from '../../../images/ruins_next.png'
import GRPrev from '../../../images/ruins_prev.png'
import GRNext from '../../../images/ruins_next.png'
import HeistPrev from '../../../images/heist_prev.png'
import HeistNext from '../../../images/heist_next.png'
import PBNext from '../../../images/pb_next.png';
import PBPrev from '../../../images/pb_prev.png';
import PGNext from '../../../images/Remote_P&G_Dashboard_RightArrow.png';
import PGPrev from '../../../images/Remote_P&G_Dashboard_LeftArrow.png';
import DepthsPrev from '../../../images/depths_prev.png'
import DepthsNext from '../../../images/depths_next.png'
import DepthsInventoryLabel from '../../../images/depths_inventory_label.png'
// Audio Imports
import frogAudio from '../../../audio/frogsfx.wav'
import owlAudio from '../../../audio/owlsfx.wav'
import birdAudio from '../../../audio/birdsfx.wav'

const frogClickAudio = new UiFx(frogAudio, {
  volume: 0.25,
})
const owlClickAudio = new UiFx(owlAudio, {
  volume: 0.25,
})
const birdClickAudio = new UiFx(birdAudio, {
  volume: 0.25,
})

// const data = require('../../../data');
// const inventory = data[0].inventory;

const PlayerInventoryModule = ({currentInventory, inventory = [], theme, title = 'Inventory', type = 'base'}) => {
  const [inventoryModalOpen, setInventoryModalOpen] = useState(false)
  const [activeItem, setActiveItem] = useState(null)

  const onClose = () => setActiveItem({})

  const loadNextButton = (theme) => {
    switch (theme) {
      case 'ruins':
        return RuinsNext
        break
      case 'gold-rush':
        return GRNext
        break
      case 'the-heist':
        return HeistNext
        break
      case 'ruins-forbidden-treasure':
        return RuinsNext
        break
      case 'prison-break':
        return PBNext;
        break;
      case 'truth-seekers':
        return PBNext;
        break;
      case 'proctor-and-gamble':
        return PGNext;
        break;
      case 'depths':
        return DepthsNext;
        break;
    }
  }

  const loadPrevButton = (theme) => {
    switch (theme) {
      case 'ruins':
        return RuinsPrev
        break
      case 'gold-rush':
        return GRPrev
        break
      case 'the-heist':
        return HeistPrev
        break
      case 'ruins-forbidden-treasure':
        return RuinsPrev
        break
      case 'prison-break':
        return PBPrev;
        break;
      case 'truth-seekers':
        return PBPrev;
        break;
      case 'proctor-and-gamble':
        return PGPrev;
        break;
      case 'depths':
        return DepthsPrev;
        break;
    }
  }

  const NextArrow = (props) => {
    const {onClick} = props
    return (
      <Button className={'nextButton'} onClick={onClick}>
        <img className={'nextImage'} src={loadNextButton(theme)}/>
      </Button>
    )
  }

  const PrevArrow = (props) => {
    const {onClick} = props
    return (
      <Button className={'prevButton'} onClick={onClick}>
        <img className={'prevImage'} src={loadPrevButton(theme)}/>
      </Button>
    )
  }

  const settings = {
    dots: false,
    infinite: false,
    centerPadding: '100px',
    speed: 500,
    slidesToShow: type === 'base' ? 6 : 3,
    slidesToScroll: type === 'base' ? 6 : 3,
    nextArrow: <NextArrow/>,
    prevArrow: <PrevArrow/>,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: type === 'base' ? 4 : 2,
          slidesToScroll: type === 'base' ? 4 : 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  }

  return (
    <div className={theme}>
      <div className={type === 'base' ? 'player-inventory-container' : 'player-inventory-lock-container'}>
        {theme === "depths" && (
          <img className="player-inventory-label" src={DepthsInventoryLabel}/>
        )}
        <div className={type === 'base' ? 'player-inventory-title' : 'player-inventory-lock-title'}>{type === 'base' ? 'Inventory' : 'Locks'}</div>
        <div className='slider-body'>
          <Slider {...settings}
                  className={type === 'base' ? 'player-inventory-item-carousel' : 'player-inventory-item-carousel-lock'}>
            {inventory.length &&
            inventory.map(
              (item) =>
                currentInventory.includes(item.id) && (
                  <Button
                    key={item.id}
                    value={item.id}
                    className="player-inventory-item-button"
                    onClick={() => {
                      setActiveItem(item);
                      switch (item.displayName) {
                        case "Bird":
                          birdClickAudio.play();
                          break;
                        case "Owl":
                          owlClickAudio.play();
                          break;
                        case "Frog":
                          frogClickAudio.play();
                          break;
                      }
                    }}
                  >
                    <img
                      className="player-inventory-item-image"
                      src={item.data.src}
                    />
                    <p>{item.displayName}</p>
                  </Button>
                )
            )}
          </Slider>
        </div>
        {activeItem && (
          <PlayerInventoryModal
            item={activeItem}
            onClose={() => setActiveItem(null)}
          />
        )}
      </div>
    </div>
  );
}

export default PlayerInventoryModule
